import { render, staticRenderFns } from "./MchNotifyList.vue?vue&type=template&id=6d5e7998"
import script from "./MchNotifyList.vue?vue&type=script&lang=js"
export * from "./MchNotifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports